import { Component, Input, Output, EventEmitter } from '@angular/core';

// INTERFACES
import { EFulfillmentOrderAction } from '@app/core/_constant/fulfillment-orders.constants';

import {
  ESalesOrderStatusValue,
  ISalesOrderActionsPayload,
} from '../../../sales-order/interfaces/sales-order.interface';
import { trackById, trackByValue } from '../../../shared/util/track-by.util';
import { IFulfillmentOrderPayload } from '../../interfaces/order-fulfillment.interface';

@Component({
  selector: 'lum-order-remote-oms-orders-table',
  templateUrl: './order-remote-oms-orders-table.component.html',
  styleUrls: ['./order-remote-oms-orders-table.component.scss'],
})
export class OrderRemoteOmsOrdersTableComponent {
  @Input()
  salesOrderShipments :any[];

  @Output()
  printShippingLabelEvent = new EventEmitter<ISalesOrderActionsPayload>();

  @Output()
  fulfillmentOrderActionEvent = new EventEmitter<{
    action :string;
    payload ?:IFulfillmentOrderPayload;
  }>();

  trackByValue = trackByValue;
  trackById = trackById;
  statusConstant = ESalesOrderStatusValue;

  printShippingLabel(shipmentId :number) :void {
    this.printShippingLabelEvent.emit({
      salesOrderShipmentId: shipmentId,
    });
  }

  createFulfillmentOrder() {
    this.fulfillmentOrderActionEvent.emit({
      action: EFulfillmentOrderAction.CREATE_FULFILLMENT_ORDER,
    });
  }

  updateFulfillmentOrder(fulfillmentOrderId :number) {
    this.fulfillmentOrderActionEvent.emit({
      action: EFulfillmentOrderAction.UPDATE_FULFILLMENT_ORDER,
      payload: { fulfillmentOrderId: fulfillmentOrderId },
    });
  }

  deleteFulfillmentOrder(fulfillmentOrderId :number) {
    this.fulfillmentOrderActionEvent.emit({
      action: EFulfillmentOrderAction.DELETE_FULFILLMENT_ORDER,
      payload: { fulfillmentOrderId: fulfillmentOrderId },
    });
  }

  updateStatusFulfillmentOrder(fulfillmentOrderId :number) {
    this.fulfillmentOrderActionEvent.emit({
      action: EFulfillmentOrderAction.UPDATE_STATUS_FULFILLMENT_ORDER,
      payload: { fulfillmentOrderId: fulfillmentOrderId },
    });
  }

  viewFulfillmentOrder(fulfillmentOrderId :number) {
    this.fulfillmentOrderActionEvent.emit({
      action: EFulfillmentOrderAction.VIEW_FULFILLMENT_ORDER,
      payload: { fulfillmentOrderId: fulfillmentOrderId },
    });
  }
}
